import * as XLSX from "xlsx";

// Columnas de la plantilla: el titulo es lo que ve el cliente en el Excel; la llave es lo que
// recibe el back (TydartBack/utils/cargaMasivaArticulos.js). "*" = obligatoria.
export const COLUMNAS_MASTERS = [
  { titulo: "SKU MASTER *", key: "sku", ancho: 26 },
  { titulo: "NOMBRE *", key: "nombre", ancho: 42 },
  { titulo: "LINEA *", key: "linea", ancho: 24 },
  { titulo: "MARCA *", key: "marca", ancho: 20 },
  { titulo: "PROVEEDOR", key: "proveedor", ancho: 24 },
  { titulo: "MEDIDA", key: "medida", ancho: 12 },
  { titulo: "MLM", key: "mlm", ancho: 16 },
  { titulo: "DESCRIPCION", key: "observaciones", ancho: 30 },
];
export const COLUMNAS_VARIANTES = [
  { titulo: "SKU MASTER", key: "skuMaster", ancho: 26 },
  { titulo: "SKU *", key: "sku", ancho: 26 },
  { titulo: "NOMBRE *", key: "nombre", ancho: 42 },
  { titulo: "VARIANTE *", key: "variante", ancho: 16 },
  { titulo: "FACTOR", key: "factor", ancho: 9 },
  { titulo: "COSTO MXN", key: "costoMX", ancho: 12 },
  { titulo: "COSTO USD", key: "costoUSD", ancho: 12 },
  { titulo: "PRECIO VENTA", key: "venta", ancho: 14 },
  { titulo: "EAN", key: "ean", ancho: 16 },
  { titulo: "MLM", key: "mlm", ancho: 16 },
  { titulo: "ASIN", key: "asin", ancho: 14 },
  { titulo: "SKU TIKTOK", key: "skuTikTok", ancho: 20 },
  { titulo: "LINEA", key: "linea", ancho: 22 },
  { titulo: "MARCA", key: "marca", ancho: 18 },
  { titulo: "PROVEEDOR", key: "proveedor", ancho: 22 },
  { titulo: "ALTO (cm)", key: "alto", ancho: 10 },
  { titulo: "ANCHO (cm)", key: "ancho", ancho: 11 },
  { titulo: "LARGO (cm)", key: "largo", ancho: 11 },
  { titulo: "PESO (kg)", key: "peso", ancho: 10 },
  { titulo: "DESCRIPCION", key: "observaciones", ancho: 30 },
];
// Encabezados alternos que tambien se aceptan
const ALIAS = {
  skuvariante: "sku",
  factordescuento: "factor",
  piezasporcaja: "factor",
  costo: "costoMX",
  costomx: "costoMX",
  costodecomprasiniva: "costoMX",
  precio: "venta",
  profundidadcm: "largo",
};

export const normHeader = (t) =>
  String(t == null ? "" : t)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]/g, "");

// Lee una hoja y regresa renglones con llaves limpias + el numero de renglon de Excel
export function leerHoja(ws, columnas) {
  const mapa = new Map(columnas.map((c) => [normHeader(c.titulo), c.key]));
  const conocidas = (c) => mapa.get(normHeader(c)) || ALIAS[normHeader(c)];
  const inicio = XLSX.utils.decode_range(ws["!ref"] || "A1").s.r;
  const filas = XLSX.utils.sheet_to_json(ws, { header: 1, defval: "", raw: true, blankrows: true });
  const iHead = filas.findIndex((f) => f.filter((c) => conocidas(c)).length >= 2);
  if (iHead < 0) return { filas: [], faltan: columnas.filter((c) => c.titulo.includes("*")).map((c) => c.titulo) };
  const head = filas[iHead].map((c) => conocidas(c) || null);
  const out = [];
  for (let i = iHead + 1; i < filas.length; i++) {
    const o = { _fila: inicio + i + 1 };
    let algo = false;
    head.forEach((k, j) => {
      if (!k) return;
      const v = filas[i][j];
      o[k] = typeof v === "string" ? v.trim() : v;
      if (v !== "" && v != null) algo = true;
    });
    if (algo) out.push(o);
  }
  const faltan = columnas.filter((c) => c.titulo.includes("*") && !head.includes(c.key)).map((c) => c.titulo);
  return { filas: out, faltan };
}

export const hojaPorNombre = (wb, nombre) => {
  const n = wb.SheetNames.find((s) => normHeader(s) === nombre);
  return n ? wb.Sheets[n] : null;
};

// Arma el Excel de la plantilla con los catalogos vigentes (nombres) en la hoja CATALOGOS y los
// masters que ya existen en la hoja MASTERS (para copiar su SKU MASTER en VARIANTES; al subir el
// archivo no se modifican ni se duplican)
export function armarPlantillaProductos({ lineas = [], marcas = [], proveedores = [], masters = [] }) {
  const wb = XLSX.utils.book_new();
  const instrucciones = [
    ["PLANTILLA DE PRODUCTOS (MASTERS Y VARIANTES)"],
    [""],
    ["1. Hoja MASTERS: ya trae los masters que existen en el sistema (no se modifican ni se duplican al subir el archivo)."],
    ["   Agrega abajo un renglón por cada master nuevo. SKU MASTER, NOMBRE, LINEA y MARCA son obligatorios."],
    ["2. Hoja VARIANTES: un renglón por cada presentación que se vende (la que lleva SKU de marketplace)."],
    ["   - SKU MASTER: el master al que pertenece. Puede venir en la hoja MASTERS o ya existir en el sistema. Vacío = producto sin master."],
    ["   - VARIANTE: la presentación (ej. 1 m, 5 m, Pack 4, Rojo)."],
    ["   - FACTOR: cuántas unidades del master trae la variante (5 m → 5, Pack 4 → 4). Vacío = 1."],
    ["   - LINEA, MARCA y PROVEEDOR vacíos se toman del master."],
    ["3. LINEA, MARCA y PROVEEDOR deben escribirse como aparecen en la hoja CATALOGOS."],
    ["4. Los renglones cuyo SKU empieza con EJEMPLO se ignoran: puedes borrarlos o dejarlos."],
    ["5. Si un SKU ya existe en el sistema no se modifica; el mismo archivo se puede volver a subir sin duplicar."],
    ["6. Al subir verás una revisión. Si hay errores no se crea nada: corrige el Excel y súbelo otra vez."],
    ["7. Las variantes nuevas se dan de alta con inventario 0 en CEDIS."],
  ];
  const wsI = XLSX.utils.aoa_to_sheet(instrucciones);
  wsI["!cols"] = [{ wch: 120 }];

  const hoja = (columnas, ejemplos) => {
    const ws = XLSX.utils.aoa_to_sheet([
      columnas.map((c) => c.titulo),
      ...ejemplos.map((e) => columnas.map((c) => (e[c.key] == null ? "" : e[c.key]))),
    ]);
    ws["!cols"] = columnas.map((c) => ({ wch: c.ancho }));
    return ws;
  };
  const ejLinea = lineas[0] || "";
  const ejMarca = marcas[0] || "";
  const wsM = hoja(COLUMNAS_MASTERS, [
    { sku: "EJEMPLO-M001-TELA-NEG", nombre: "Tela Vinipiel Negro 1.40m", linea: ejLinea, marca: ejMarca, medida: "1.40 m" },
    ...masters,
  ]);
  const wsV = hoja(COLUMNAS_VARIANTES, [
    { skuMaster: "EJEMPLO-M001-TELA-NEG", sku: "EJEMPLO-TELA-NEG-1M", nombre: "Tela Vinipiel Negro 1 m", variante: "1 m", factor: 1, costoMX: 65, venta: 129, mlm: "MLM0000000000" },
    { skuMaster: "EJEMPLO-M001-TELA-NEG", sku: "EJEMPLO-TELA-NEG-5M", nombre: "Tela Vinipiel Negro 5 m", variante: "5 m", factor: 5, costoMX: 245, venta: 499 },
  ]);
  const largo = Math.max(lineas.length, marcas.length, proveedores.length);
  const catalogos = [["LINEAS", "MARCAS", "PROVEEDORES"]];
  for (let i = 0; i < largo; i++) catalogos.push([lineas[i] || "", marcas[i] || "", proveedores[i] || ""]);
  const wsC = XLSX.utils.aoa_to_sheet(catalogos);
  wsC["!cols"] = [{ wch: 30 }, { wch: 30 }, { wch: 34 }];

  XLSX.utils.book_append_sheet(wb, wsI, "INSTRUCCIONES");
  XLSX.utils.book_append_sheet(wb, wsM, "MASTERS");
  XLSX.utils.book_append_sheet(wb, wsV, "VARIANTES");
  XLSX.utils.book_append_sheet(wb, wsC, "CATALOGOS");
  return wb;
}
